import { render, staticRenderFns } from "./StaffCardLog.vue?vue&type=template&id=050fa5e1&scoped=true"
import script from "./StaffCardLog.vue?vue&type=script&lang=js"
export * from "./StaffCardLog.vue?vue&type=script&lang=js"
import style0 from "./StaffCardLog.vue?vue&type=style&index=0&id=050fa5e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050fa5e1",
  null
  
)

export default component.exports